"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nestGet_1 = __importDefault(require("./nestGet"));
const miniHandlebars = (template, data) => {
    const pattern = /{{\s*([\w\.]+?)\s*}}/g;
    return template.replace(pattern, (_, token) => (0, nestGet_1.default)(data, token.split('.')) || '');
};
exports.default = miniHandlebars;
